<template>
  <div class="module-material-types-page">
    <h1>{{ $t('heading.moduleMaterialTypesPage') }}</h1>
    <md-list>
      <md-list-item v-bind:key="item.id" v-for="item in moduleMaterialTypes.items">
        <md-icon>arrow_forward</md-icon>
        <span class="md-list-item-text">
          <router-link :to="{ path: '/document/' + item.materialType + '/' + item.language + '?limit=50&offset=0' }">{{ $t('label.materialType-' + item.materialType ) }} ({{$t('label.lang-' + item.language)}})</router-link>
        </span>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ModuleMaterialTypesPage',
  computed: {
    ...mapState({
      moduleMaterialTypes: state => state.moduleMaterialTypes.all
    })
  },
  created () {
    this.getAllMaterialTypes({ module: 'headpower' })
  },
  methods: {
    ...mapActions('moduleMaterialTypes', {
      getAllMaterialTypes: 'getAll'
    })
  }
}
</script>

<style scoped>
.md-table {
  text-align: left;
}
</style>
